/**
 * DCC专员跟进 - 跟进概况
 */
export default {
  field_from_api: {
    contacted: {
      name: '已联系'
    },
    booked: {
      name: '已预约'
    },
    arrived: {
      name: '已到店'
    },
    dealed: {
      name: '已成交'
    },
    defeated: {
      name: '已战败'
    }
  },
  field_from_api1: {
    not_contacted: {
      name: '未联系'
    },
    contacted: {
      name: '已联系'
    },
    booked: {
      name: '已预约'
    },
    arrived: {
      name: '已到店'
    },
    dealed: {
      name: '已成交'
    },
    defeated: {
      name: '已战败'
    }
  },
  getData (params = {}) {
    this.$rest.dataAnalysis.getAllClues(params).then(res => {
      if (res.code === 0) {
        this.dataList = res.data
      } else {
        this.showToast(res.message)
      }
    })
  }
}
